import {ApplicationUserDto, ApplicationUserRegisterDto} from "../../../api";
import UserModalForm from "../userModalForm/userModalForm";

export default function UserModalFormAddContainer(props: UserModalFormAddContainerProps) {
    return <UserModalForm
        isModalVisible={props.addFormVisibility}
        setModalVisibility={props.onFinish}
        onSubmit={props.onSubmit}
        saveButtonTitle="Zapisz"
        cancelButtonTitle="Anuluj"
        modalTitle={props.title}
        initialValues={props.userToEdit!}
    />
}

interface UserModalFormAddContainerProps {
    onFinish: (refreshList: boolean) => void,
    onSubmit: (values: ApplicationUserRegisterDto | ApplicationUserDto) => Promise<any>,
    addFormVisibility: boolean,
    title: string,
    userToEdit: ApplicationUserDto | null;
}
